import { Grid, useTheme } from '@mui/material';

interface IProps {
    children: React.ReactNode
    onSubmit?: () => void
}

let FilterContainer = ({ children, onSubmit }: IProps) => {
    let theme = useTheme();

    return (
        <form
            onSubmit={(e) => {
                if (onSubmit) {
                    e.preventDefault(); onSubmit()
                }
            }}
        >
            <Grid
                container
                alignItems="center"
                style={{ marginBottom: theme.spacing(2) }}
            >
                {children}
            </Grid>
        </form>
    )
}


export default FilterContainer;